import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";
import Legal from "../pages/legal/page";
import Privacy from "../pages/privacy/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/a-propos", element: <About /> },
  { path: "/contact", element: <Contact /> },
  { path: "/conditions-generales", element: <Legal /> },
  { path: "/politique-confidentialite", element: <Privacy /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
